import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNotificationsContext } from "common/context/NotificationsProvider"
import { useTranslation } from "react-i18next"
import {
  getNotifiactionInfo,
  getValueByTitle,
  notificationMessage,
} from "./constants"

import "../style.scss"

const NotificationsMenuItem = ({ notification }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'handleOpenNotification' does not exist o...
  const { handleOpenNotification, hideNotifications } =
    useNotificationsContext()

  const onNotificationClick = () => {
    const selectedNotification = {
      id: notification.id,
      type: notification.type,
      read: notification.read,
      messageId: getValueByTitle(notification, "Id"),
      empresaId: getValueByTitle(notification, "EmpresaId"),
    }
    handleOpenNotification(selectedNotification)
    hideNotifications()
  }

  return (
    <div
      className='flex-row notifications-menu-item w-100 d-flex'
      onClick={onNotificationClick}
    >
      <div className='mr-3 notifications-menu-item-icon-container d-flex'>
        <FontAwesomeIcon
          className='m-auto notifications-menu-item-icon'
          icon={[
            // @ts-expect-error TS(2322): Type '"fa-light"' is not assignable to type 'IconP...
            "fa-light",
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'IconName'...
            getNotifiactionInfo(notification.type)?.icon || "paperclip",
          ]}
        />
      </div>
      <div className='text-left notifications-menu-item-info-container d-flex flex-column justify-content-center '>
        {notificationMessage(notification, t)}
      </div>
    </div>
  )
}

export default NotificationsMenuItem
